import { createContext } from 'react';

import type { WhatsAppCallSession } from '../types/whatsapp-call.types';

export type WhatsAppCallContextValue = {
  calls: Record<string, WhatsAppCallSession>;
  primaryCall: WhatsAppCallSession | null;
  isBusy: boolean;
  startOutboundCall: (conversationId: string, contact?: { firstName?: string; lastName?: string; phone?: string }) => Promise<void>;
  acceptCall: (callId: string) => Promise<void>;
  rejectCall: (callId: string) => void;
  hangUp: (callId: string) => void;
  toggleMute: (callId: string) => void;
  isMuted: (callId: string) => boolean;
  toggleHold: (callId: string) => void;
  isHeld: (callId: string) => boolean;
  selectedMicrophoneId: string;
  setSelectedMicrophoneId: (deviceId: string) => void;
  microphones: MediaDeviceInfo[];
};

export const WhatsAppCallContext = createContext<WhatsAppCallContextValue | undefined>(undefined);
